import React from 'react';
import styles from "./Chatbot.module.scss";

type MessagePartsContainerProps = {
    messageParts: string[];
    sender: string;
};

const MessagePartsContainer: React.FC<MessagePartsContainerProps> = ({ messageParts, sender }) => (
    <div
        className={
            sender === "user"
                ? `${styles.messages__item__typing} ${styles.messages__item}`
                : `${styles.messages__item__operator} ${styles.messages__item}`
        }
    >
        {messageParts.map((part, partIdx) => (
            <React.Fragment key={`message-part-${partIdx}`}>
                {part}
                {partIdx < messageParts.length - 1 && <br />}
            </React.Fragment>
        ))}
    </div>
);

export default MessagePartsContainer;